import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  SelectChangeEvent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Autocomplete,
  Chip,
  TextField,
  Typography,
} from "@mui/material";
import api from "src/services/api";
import useAuthenticate from "src/hooks/useAuthenticate";

interface Tournament {
  id: number;
  name: string;
}

interface ShirtsModalProps {
  showShirtsModal: boolean;
  handleCloseShirtsModal: () => void;
  tournaments: Tournament[];
}

interface ShirtsDataItem {
  size: string;
  quantity: number;
  price: number;
  totalPrice: number;
}

interface ShirtsDataResponse {
  pending: ShirtsDataItem[];
  paid: ShirtsDataItem[];
}

export function ShirtsModal({
  showShirtsModal,
  handleCloseShirtsModal,
  tournaments,
}: ShirtsModalProps) {
  const [selectedTournament, setSelectedTournament] = React.useState<
    number | ""
  >("");
  const [shirtsData, setShirtsData] = useState<ShirtsDataResponse>({
    pending: [],
    paid: [],
  });
  const { getToken } = useAuthenticate();

  const fetchShirtsForTournament = (id: number) => {
    api
      .get(`/administrators/tournaments/thisrts/${id}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      })
      .then((res) => {
        console.log(res.data);
        setShirtsData(res.data);
      })
      .catch(() => {
        setShirtsData({ pending: [], paid: [] });
      });
  };

  return (
    <Dialog
      open={showShirtsModal}
      onClose={handleCloseShirtsModal}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: "700px",
        },
      }}
    >
      <DialogTitle>Relatório de camisas</DialogTitle>

      <DialogContent>
        {/* Select de Torneio */}
        <Autocomplete
          options={tournaments.sort((a, b) => a.name.localeCompare(b.name))}
          getOptionLabel={(option) => option.name}
          value={tournaments.find((t) => t.id === selectedTournament) ?? null}
          onChange={(event, newValue) => {
            const id = newValue ? newValue.id : "";
            setSelectedTournament(id);
            if (newValue) {
              fetchShirtsForTournament(newValue.id);
            } else {
              setShirtsData({ pending: [], paid: [] });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Digite para buscar torneios..."
              variant="outlined"
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                },
              }}
            />
          )}
          filterOptions={(options, { inputValue }) => {
            return options.filter((option) =>
              option.name.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
          noOptionsText="Nenhum torneio encontrado"
          loadingText="Carregando torneios..."
          sx={{
            mt: 1,
            "& .MuiAutocomplete-paper": {
              backgroundColor: "white",
            },
          }}
        />

       {shirtsData && (
  <>
    <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
      Camisas — Inscrições pagas
    </Typography>

    <Box
      component={Paper}
      sx={{
        mt: 1,
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Table sx={{ minWidth: 500 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Tamanho</strong>
            </TableCell>
            <TableCell>
              <strong>Quantidade</strong>
            </TableCell>
            <TableCell>
              <strong>Preço total</strong>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {shirtsData.paid
            .slice()
            .sort((a, b) => b.quantity - a.quantity)
            .map((item) => (
              <TableRow key={item.size}>
                <TableCell>{item.size}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>R$ {item.totalPrice}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Box>

    <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
      Camisas — Inscrições Pendentes
    </Typography>

    <Box
      component={Paper}
      sx={{
        mt: 1,
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Table sx={{ minWidth: 500 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Tamanho</strong>
            </TableCell>
            <TableCell>
              <strong>Quantidade</strong>
            </TableCell>
            <TableCell>
              <strong>Preço total</strong>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {shirtsData.pending
            .slice()
            .sort((a, b) => b.quantity - a.quantity)
            .map((item) => (
              <TableRow key={item.size}>
                <TableCell>{item.size}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>R$ {item.totalPrice}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Box>
  </>
)}

      </DialogContent>
    </Dialog>
  );
}
